import { Controller } from "stimulus"
import {DataTable} from "simple-datatables"

export default class extends Controller {

  initialize() {
    console.warn("Loaded    ")
    this.dataTable = new DataTable("#auditLogTable", {
      perPage: 15,
      perPageSelect: false,
      labels: {
        noRows: "No logs found",
        info: "Showing {start} to {end} of {rows} log entries"
      }
    });
    //this.ourSearchBar = document.getElementById('auditLogSearchBar');
    //this.simpleDatatableSearch = document.getElementsByClassName('dataTable-input')[0];
    //this.setupDataTableSearch();

  }
  setupDataTableSearch(){
    this.ourSearchBar.addEventListener('keyup', (e) => {
      this.simpleDatatableSearch.value = this.ourSearchBar.value;
      this.simpleDatatableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
  }
}